import { takeLatest, put } from 'redux-saga/effects';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import {
  clearProductList,
  getProductListFail,
  getProductListRequest,
  getProductListSuccess,
} from './actions';
import ProductService from '../../../services/ProductService';
import { ListParams } from '../../../types/main';

function* getProductList({ payload }: ReturnType<typeof getProductListRequest>) {

  const defaultParams: ListParams = {
    filter: {
      is_plan: 1,
    },
  };

  try {
    const list = yield apiCall(ProductService.list, payload ? payload : defaultParams);
    yield put(getProductListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getProductListFail());
  }
}

function* clearList() {
  yield put(clearProductList());
}

export default [
  takeLatest(getProductListRequest.type, getProductList),
  takeLatest(logOut.type, clearList),
];
